/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ mcp: NonNullable<unknown>, signup: NonNullable<unknown> }} Seo_Endpoint_A_AgentInputs */

const en_seo_endpoint_a_agent = /** @type {(inputs: Seo_Endpoint_A_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yes. An agent can connect to the AnyAPI MCP server at ${i?.mcp}, or create its own free-trial key with one unauthenticated POST to ${i?.signup} and call this endpoint over HTTP.`)
};

const zh_hans1_seo_endpoint_a_agent = /** @type {(inputs: Seo_Endpoint_A_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`可以。智能体可以连接 ${i?.mcp} 上的 AnyAPI MCP 服务器，或者向 ${i?.signup} 发送一次无需认证的 POST 来创建自己的免费试用密钥，再通过 HTTP 调用这个接口。`)
};

const pt_br2_seo_endpoint_a_agent = /** @type {(inputs: Seo_Endpoint_A_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sim. Um agente pode se conectar ao servidor MCP da AnyAPI em ${i?.mcp}, ou criar a própria chave de teste grátis com um único POST sem autenticação para ${i?.signup} e chamar este endpoint por HTTP.`)
};

const es_seo_endpoint_a_agent = /** @type {(inputs: Seo_Endpoint_A_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sí. Un agente puede conectarse al servidor MCP de AnyAPI en ${i?.mcp}, o crear su propia clave de prueba gratis con un solo POST sin autenticar a ${i?.signup} y llamar a este endpoint por HTTP.`)
};

const fr_seo_endpoint_a_agent = /** @type {(inputs: Seo_Endpoint_A_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oui. Un agent peut se connecter au serveur MCP d’AnyAPI à ${i?.mcp}, ou créer sa propre clé d’essai gratuit avec un seul POST non authentifié vers ${i?.signup} et appeler cet endpoint en HTTP.`)
};

const de_seo_endpoint_a_agent = /** @type {(inputs: Seo_Endpoint_A_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ja. Ein Agent kann sich mit dem AnyAPI-MCP-Server unter ${i?.mcp} verbinden oder mit einem unauthentifizierten POST an ${i?.signup} einen eigenen kostenlosen Test-Schlüssel erstellen und diesen Endpoint über HTTP aufrufen.`)
};

const ru_seo_endpoint_a_agent = /** @type {(inputs: Seo_Endpoint_A_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Да. Агент может подключиться к MCP-серверу AnyAPI по адресу ${i?.mcp} или создать собственный бесплатный пробный ключ одним POST без аутентификации на ${i?.signup} и вызывать этот эндпоинт по HTTP.`)
};

const it_seo_endpoint_a_agent = /** @type {(inputs: Seo_Endpoint_A_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sì. Un agente può collegarsi al server MCP di AnyAPI su ${i?.mcp}, oppure creare da solo la propria chiave di prova gratuita con un POST non autenticato a ${i?.signup} e chiamare questo endpoint via HTTP.`)
};

/**
* | output |
* | --- |
* | "Yes. An agent can connect to the AnyAPI MCP server at {mcp}, or create its own free-trial key with one unauthenticated POST to {signup} and call this endpoin..." |
*
* @param {Seo_Endpoint_A_AgentInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_a_agent = /** @type {((inputs: Seo_Endpoint_A_AgentInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_A_AgentInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_a_agent(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_a_agent(inputs)
	if (locale === "es") return es_seo_endpoint_a_agent(inputs)
	if (locale === "fr") return fr_seo_endpoint_a_agent(inputs)
	if (locale === "de") return de_seo_endpoint_a_agent(inputs)
	if (locale === "ru") return ru_seo_endpoint_a_agent(inputs)
	if (locale === "it") return it_seo_endpoint_a_agent(inputs)
	return en_seo_endpoint_a_agent(inputs)
});